import React, { useEffect, useState } from "react";
import "./FixedEmpJobwork.css";
import { fetchEmployeeData } from "../../Store/PHPSlice/Employee";
import { useDispatch, useSelector } from "react-redux";
import { selectEmployees } from "../Selectors/Master/ItemSelectors";
import DropdownWithBtn from "../FieldsComponents/DropdownWithBtn";
import {
  Grid, InputLabel, FormControl, TextField, Button, Paper, useMediaQuery, FormHelperText, Typography, Checkbox, CircularProgress,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@mui/material';
import TitleBar from "../TitleBar";
import { jobworkMenu } from "../TitleList";
import axios from "axios";
import { getCurrentDate } from "../../Utils/Dateutils";

const summaryCols = ["Advance", "Baki", "PF", "ESI", "PT", "Machinary", "Purchase"];

const FixedEmpJobwork = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const userdata = JSON.parse(localStorage.getItem("user"));
  const [formData, setFormData] = useState({
    entrydt: getCurrentDate(),
    totworkingHrs: '0',
    dedamt: '0',
    finalhr_amt: '0',
    finalday_amt: '0',
    amt: '0',
    totdays: '0',
    present_days: '0',
    leave_days: "0",
    leave_amt: '0',
    perhr_amt: '0',
    perday_amt: '0',
    extra_hrs: "0",
    extrahr_amt: 0
  });
  const [employee, setEmployee] = useState();
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [rateHoursDiff, setRateHoursDiff] = useState("no");
  const [hoursBy, setHoursBy] = useState("hours");

  const [attendanceData, setAttendanceData] = useState([]);
  const [attendanceInfo, setAttendanceInfo] = useState([]);
  const [fixEmpData, setFixEmpData] = useState({});
  const [extraAmt, setExtraAmt] = useState([]);

  const isDesktop = useMediaQuery('(min-width:768px)');
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [loading, setLoading] = useState(false);
  const emplist = useSelector(selectEmployees);
  const actionMap = {
    empId: fetchEmployeeData
    // Add more mappings if needed
  };

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchEmployeeData());
    Object.keys(openDropdowns).forEach((dropdown) => {
      if (openDropdowns[dropdown]) {
        const action = actionMap[dropdown];
        if (action) {
          dispatch(action());
        }
      }
    });
  }, [openDropdowns, dispatch]);


  const handleDropdownOpen = (dropdown) => {
    setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
  };

  const handleDropdownClose = (dropdown) => {
    setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
  };
  const calculateTotalDays = (from, to) => {
    if (!from || !to) return 0;

    const start = new Date(from);
    const end = new Date(to);

    const diff = end - start;

    return diff >= 0
      ? Math.floor(diff / (1000 * 60 * 60 * 24)) + 1
      : 0;
  };


  const fetchEmpAttendanceforjobwork = async (empId, fromdt, todt) => {
    try {
      const res = await axios.get(`${baseUrl}?apicall=getEmpAtteandanceDataForJobwork&empId=${empId}&fromdt=${fromdt}&todt=${todt}`);
      if (res.data.status === "pending") {
        alert(res.data?.msg);
      } else if (res.data?.status === "failed") {
        alert(res.data?.msg[0]);
      } else {
        // console.log(res.data);
        const data = res?.data;
        if (data) {
          setAttendanceData(data?.attendance_data);
          setAttendanceInfo(data?.attendance_info);
          setFixEmpData(data?.fixed_emp_data);
          const workType = data?.fixed_emp_data?.work_type?.toLowerCase();

if (workType === "hr") {
  setHoursBy("hours");
}
else if (workType === "day") {
  setHoursBy("days");
}
          // const timeToMinutes = (time) => {
          //   if (!time) return 0;
          //   const [hrs, mins] = time.split(':').map(Number);
          //   return (hrs * 60) + mins;
          // };

          const timeToMinutes = (time) => {
            if (!time) return 0;

            // If format is HH:MM
            if (time.includes(":")) {
              const [h, m] = time.split(":").map(Number);
              return h * 60 + m;
            }

            // If format is decimal (8.43 = 8h 43m)
            const [h, m] = time.split(".").map(Number);
            return (h * 60) + (m || 0);
          };
          const totalMinutes = data?.attendance_info?.reduce((acc, row) => {
            return acc + timeToMinutes(row.tothrs);
          }, 0);

          const minutesToTime = (mins) => {
            const hrs = Math.floor(mins / 60);
            const remMins = mins % 60;
            return `${String(hrs).padStart(2, '0')}.${String(remMins).padStart(2, '0')}`;
          };
          //           const timeToMinutes = (time) => {
          //   if (!time) return 0;

          //   // If format is HH:MM
          //   if (time.includes(":")) {
          //     const [h, m] = time.split(":").map(Number);
          //     return h * 60 + m;
          //   }

          //   // If format is decimal (8.43 = 8h 43m)
          //   const [h, m] = time.split(".").map(Number);
          //   return (h * 60) + (m || 0);
          // };

          // const minutesToTime = (mins) => {
          //   const hrs = Math.floor(mins / 60);
          //   const rem = mins % 60;

          //   return `${hrs}.${String(rem).padStart(2, "0")}`;
          // };

          const totalExtraMinutes = data?.attendance_info?.reduce((acc, row) => {
            return acc + timeToMinutes(row.exthrs);
          }, 0);

          const totworkhrs = minutesToTime(totalMinutes);
          const totexthrs = minutesToTime(totalExtraMinutes);

          // const totworkhrs = data?.attendance_info?.reduce((acc, sum) => acc + parseFloat(sum.tothrs || 0), 0)?.toFixed(2);
          const perhr_amt = data?.fixed_emp_data?.perhr_amt;
          const perday_amt = data?.fixed_emp_data?.perday_amt;


          // const totdays = data?.attendance_info?.length;
         // const totdays = calculateTotalDays(fromdt, todt);

          // const present_days = data?.attendance_info?.filter(item => item.tothrs !== '0')?.length;
          // const leave_days = data?.attendance_info?.filter(item => item.tothrs === '0')?.length;
          // Calculate Present Days Based On Schedule Type
const present_days = data?.attendance_info?.reduce((acc, item) => {

  const type = item.schedule_type
    ?.replace(/\s+/g, '')   // remove all spaces
    ?.toLowerCase();
  //alert("Schedule Type: " + type);

  if (type === "fullday") return acc + 1;
  if (type === "halfday") return acc + 0.5;
  if (type === "hr") return acc + 0;
 // alert("No Match Found. Returning acc: " + acc);

  return acc;

}, 0) || 0;

const totdays = calculateTotalDays(fromdt, todt);
const leave_days = totdays - present_days;
//let leave_days = totdays - present_days;

// If decimal comes (.5) then consider only integer
//leave_days = Math.floor(leave_days);
//alert(`Total Days: ${totdays}\nPresent Days: ${present_days}\nleave_days:${leave_days}`);
          let amt = 0;
          let leave_amt = 0;

          let tothr_amt = perhr_amt * totworkhrs;
          let totexhrs_amt = (totexthrs * perhr_amt).toFixed(2);
          let finalhr_amt = tothr_amt;

          // let totday_amt = perday_amt * totdays;
          // leave_amt = perday_amt * leave_days;
          // let finalday_amt = totday_amt - leave_amt + totexhrs_amt;
          let totday_amt = perday_amt * present_days;
leave_amt = perday_amt * leave_days;

let finalday_amt =
  totday_amt +
  parseFloat(totexhrs_amt || 0);
  //alert("finaleday_amt=>"+finalday_amt);
          setFormData(prev => ({
            ...prev,
            totworkingHrs: totworkhrs || 0,
            perhr_amt: perhr_amt || 0,
            totdays: totdays || 0,
            present_days: present_days || 0,
            leave_days: leave_days || 0,
            perday_amt: perday_amt || 0,
            leave_amt: leave_amt || 0,
            totday_amt: totday_amt || 0,
            tothr_amt: tothr_amt || 0,
            finalday_amt: finalday_amt || 0,
            finalhr_amt: finalhr_amt || 0,
            extra_hrs: totexthrs || 0,
            extrahr_amt: totexhrs_amt || 0
          }));
          setExtraAmt(data?.Advance_amt);
        }

      }
    } catch (error) {
      console.error(error);
    }
  };

  const summaryData = {
    total: [23049, 0, 0, 0, 0, 0],
    less: [0, 0, 0, 0, 0, 0],
    balance: ["23049.00", "0.00", "0.00", "0.00", "0.00", "0.00"],
  };

  const purchaseData = [
    { date: "2015-12-17", dcNo: "17021", netAmount: 207 },
    { date: "2018-07-14", dcNo: "24130", netAmount: 150 },
    { date: "2018-07-14", dcNo: "24131", netAmount: 115 },
    { date: "2018-07-24", dcNo: "24142", netAmount: 85 },
    { date: "2018-07-22", dcNo: "24141", netAmount: 0 },
    { date: "2018-08-31", dcNo: "53098", netAmount: 1155 },
    { date: "2018-09-20", dcNo: "53106", netAmount: 50 },
  ];

  const handleNavigateItem = () => {
    window.open(`/EmployeeEdit`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
  };

  const handleDropdownChange = (e, dropdownType) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      [dropdownType]: value
    });

    if (dropdownType === "empId") {
      const selectedEmp = emplist?.data?.find(e => e.ID === value);

  setFormData(prev => ({
    ...prev,
    empId: value,
    punchingId: selectedEmp?.punchId || ''
  }));
      fetchEmpAttendanceforjobwork(value, fromDate, toDate);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const dropdownlistfirst = [
    {
      label: 'Employee',
      id: 'empId',
      options: emplist?.data || [],
      value: formData.empId,
      onChange: (newValue) => handleDropdownChange({ target: { name: 'empId', value: newValue ? newValue.ID : '' } }, 'empId'),
      getOptionLabel: (option) => option.empNm || '',
      isOptionEqualToValue: (option, value) => option.ID === value.ID,
      valueFinder: (options, value) => {
        if (Array.isArray(options)) {
          return options.find(item => item.ID === value) || null;
        }
        return null;
      },
      handleAddNew: () => handleNavigateItem(),
      btnlabel: 'New',
      handleDropdownOpen: () => handleDropdownOpen('empId'),
      handleDropdownClose: () => handleDropdownClose('empId'),
    },
  ];

  const handleLessChange = (index, event) => {
    const value = parseFloat(event.target.value);

    if (isNaN(value)) {
      return; // Prevent invalid input (like letters)
    }

    const updatedExtraAmt = [...extraAmt];
    const item = updatedExtraAmt[index];

    // Check if the entered 'less' value is greater than 'balamt'
    if (value <= item.balamt) {
      item.less = value;
      item.bal = item.balamt - value;
      setExtraAmt(updatedExtraAmt);
    } else {
      // Optionally handle the case where less is greater than balamt
      alert('The less amount cannot be greater than the total balance amount');
    }

    const totsum = updatedExtraAmt?.reduce((acc, amt) => acc + parseFloat(amt?.less || 0), 0);
    const finalday_amt = parseFloat(formData.totday_amt) + parseFloat(formData.extrahr_amt) - totsum;

    const finalhr_amt = parseFloat(formData.tothr_amt) > 0 ? parseFloat(formData.tothr_amt) - totsum : 0;
    setFormData(prev => ({
      ...prev,
      finalday_amt: Math.round(finalday_amt),
      finalhr_amt: Math.round(finalhr_amt),
      dedamt: Math.round(totsum)
    }));
  };

  const handleHoursClick = (e) => {
    const { name, value } = e.target;
    setHoursBy(value)
    if (value === "days" && formData.totdays > 0) {
      const leave_amt = parseFloat(formData.perday_amt) * parseFloat(formData.leave_days);
      const finalamt = parseFloat(formData.totday_amt) + parseFloat(formData.extrahr_amt)  - parseFloat(formData.dedamt);
      setFormData(prev => ({
        ...prev,
        leave_amt: leave_amt,
        finalday_amt: Math.round(finalamt)
      }));
    } else {
      if (fromDate && toDate) {
        const start = new Date(fromDate);
        const end = new Date(toDate);

        // Difference in days (inclusive)
        const diffTime = end - start;
        const diffDays = diffTime / (1000 * 60 * 60 * 24) + 1;

        const amt = Math.round(diffDays * parseFloat(formData.perday_amt));

        setFormData(prev => ({
          ...prev,
          totdays: diffDays,
          totday_amt: amt,
          finalday_amt: amt,
          leave_amt: '0',
          dedamt: '0'
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          leave_amt: '0',
          finalday_amt: '0',
          dedamt: '0',
          finalhr_amt: '0'
        }));
      }

    }
  };

  const attendanceHeader = ["Date", "In1", "Out1", "In2", "Out2", "In3", "Out3", "In4", "Out4", "Working Hrs", "Extra Hrs", "Schedule Type"];

  const postObj = () => {

    const leave_amt = hoursBy === "days" ? formData.leave_amt : 0;
    const leave_days = hoursBy === "days" ? formData.leave_days : 0;

    const amt = hoursBy === "days" ? formData.totday_amt : formData.tothr_amt;
    const perhr_amt = formData.perhr_amt;
    const perday_amt = hoursBy === "days" ? formData.perday_amt : 0;
    const finalamt = hoursBy === "days" ? formData.finalday_amt : formData.finalhr_amt;
    const present_days = hoursBy === "days" ? formData.present_days : 0;
    const totwork_hr = hoursBy === "hours" ? formData.totworkingHrs : 0;
    const totdays = hoursBy === "days" ? formData.totdays : 0;

    const extra_hrs = hoursBy === "days" ? formData.extra_hrs : 0;
    const extrahr_amt = hoursBy === "days" ? formData.extrahr_amt : 0;

    const data = {
      entrydt: formData.entrydt,
      Hours_sts: hoursBy,
      fromdt: fromDate,
      todt: toDate,
      empId: formData.empId,
      totworkingHrs: totwork_hr,
      advanceAmt: extraAmt,
      leave_amt: leave_amt,
      leave_days: leave_days,
      perhr_amt: perhr_amt,
      perday_amt: perday_amt,
      amt: amt,
      dedamt: formData.dedamt,
      finalamt: finalamt,
      narr: formData.narr || '',
      present_days: present_days,
      attendanceinfo: attendanceInfo,
      attendancedata: attendanceData,
      userId: userdata?.ID,
      totdays: totdays,
      extra_hrs: extra_hrs,
      extrahr_amt: extrahr_amt
    };
    return data;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const finaldata = postObj();
    // console.log(finaldata);
    setLoading(true);
    try {
      const res = await axios.post(`${baseUrl}?apicall=insertFixedEmployeeJobwork`, finaldata);
      const data = res.data;
      if (data?.status === "success") {
        alert(data.msg);
        window.location.reload();
      } else {
        if (Array.isArray(data?.msg)) {
          alert(data.msg.join("\n"));
        } else if (typeof data?.msg === "string") {
          alert(data.msg);
        }
      }
    } catch (error) {
      console.error('Error while making POST request:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlehoursChange = (e) => {
    const { name, value } = e.target;
    const perhr_amt = parseFloat(formData.perhr_amt);

    const amt = perhr_amt * Number(value);
    const dedamt = parseFloat(formData.dedamt);
    const totamt = amt - dedamt

    setFormData(prev => ({
      ...prev,
      tothr_amt: amt,
      [name]: value,
      finalhr_amt: totamt,

    }));
  };

  const handledaysChange = (e) => {
    const { name, value } = e.target;
    const perday_amt = parseFloat(formData.perday_amt);
    if (name === "totdays") {
      const amt = perday_amt * Number(value);
      const leave_amt = perday_amt * parseFloat(formData.leave_days);
      const totamt = amt + parseFloat(formData.extrahr_amt) - parseFloat(formData.dedamt);
      setFormData(prev => ({
        ...prev,
        totdays: value,
        totday_amt: amt,
        leave_amt: leave_amt,
        finalday_amt: totamt
      }));
    }
    if (name === "leave_days" && value < formData.totdays) {
      const leave_amt = perday_amt * Number(value);
      const amt = perday_amt * parseFloat(formData.totdays);
      const totamt = amt + parseFloat(formData.extrahr_amt) - parseFloat(formData.dedamt) - leave_amt;

      const present_days = parseFloat(formData.totdays) - Number(value);
      setFormData(prev => ({
        ...prev,
        [name]: value,
        present_days: present_days,
        totday_amt: amt,
        leave_amt: leave_amt,
        finalday_amt: totamt
      }));
    }

    // if (name === "present_days" && value < formData.totdays) {
    //   const leave_days = parseFloat(formData.totdays) - Number(value);
    //   const leave_amt = perday_amt * leave_days;
    //   const totamt = parseFloat(formData.totday_amt) + parseFloat(formData.extrahr_amt) - leave_amt - parseFloat(formData.dedamt);

    //   setFormData(prev => ({
    //     ...prev,
    //     [name]: value,
    //     leave_amt: leave_amt,
    //     leave_days: leave_days,
    //     finalday_amt: totamt
    //   }));
    // }
    if (name === "present_days"  && value < formData.totdays) {

  const present = Number(value);
  const total = Number(formData.totdays);

  if (present > total) return; // prevent invalid input

  const leave_days = total - present;

  // ✅ Amount based on PRESENT DAYS
  const totday_amt = perday_amt * present;

  const leave_amt = perday_amt * leave_days;

  const finalamt =
    totday_amt +
    parseFloat(formData.extrahr_amt) -
    parseFloat(formData.dedamt);

  setFormData(prev => ({
    ...prev,
    present_days: present,
    leave_days: leave_days,
    totday_amt: totday_amt,
    leave_amt: leave_amt,
    finalday_amt: Math.round(finalamt)
  }));
}

    //if (name === "extra_hrs" && value > 0)
      if (name === "extra_hrs") {
      const perhr_amt = parseFloat(formData.perhr_amt) || 0;
      const extraHours = parseFloat(value) || 0;

      const extrahr_amt = Math.round(perhr_amt * extraHours);

      const totday_amt = parseFloat(formData.totday_amt) + extrahr_amt;
      const totamt = Math.round(totday_amt -  parseFloat(formData.dedamt));

      setFormData(prev => ({
        ...prev,
        [name]: value,
        extrahr_amt: extrahr_amt,
        finalday_amt: totamt
      }));
    }
  };


  return (
    <>
      <TitleBar data={jobworkMenu} />
      <div className="job-wrapper">
        <div className="job-title">Fixed Employee Job Work Entry</div>

        <div className="job-paper">
          <div className="job-container">
            {/* Left Section */}
            <div className="left-section">
              {/* Row 1 */}
              {/* <div className="form-row">
                <label className="form-label">Rate / Hours Diff.</label>
                <div className="radio-group">
                  <label className="radio-label">
                    <input
                      type="radio"
                      value="yes"
                      checked={rateHoursDiff === "yes"}
                      onChange={(e) => setRateHoursDiff(e.target.value)}
                    /> Yes
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      value="no"
                      checked={rateHoursDiff === "no"}
                      onChange={(e) => setRateHoursDiff(e.target.value)}
                    /> No
                  </label>
                </div>
              </div> */}

              {/* <div className="form-row">
                <label className="form-label">Designation</label>
                <span className="designation-text">: Employee Computer Department Fixed</span>
              </div> */}

              <div className="form-row">
                <label className="form-label">Entry Date</label>
                <input
                  type="date"
                  className="date-input"
                  value={formData.entrydt}
                  name="entrydt"
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-row">
                <label className="form-label">Hours By</label>
                <div className="radio-group">
                  <label className="radio-label">
                    <input
                      type="radio"
                      value="days"
                      checked={hoursBy === "days"}
                      onChange={(e) => handleHoursClick(e)}
                    /> Days
                  </label>
                  <label className="radio-label">
                    <input
                      type="radio"
                      value="hours"
                      checked={hoursBy === "hours"}
                      onChange={(e) => handleHoursClick(e)}
                    /> Hours
                  </label>
                </div>
              </div>



              {/* Row 2 */}
              <div className="form-row">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="date-input"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
              </div>

              {hoursBy === "days" &&
                <>
                  <div className="form-row">
                    <label className="form-label">Total Days</label>
                    <input className="number-input" name="totdays" value={formData.totdays}
                      onChange={(e) => handledaysChange(e)} />
                  </div>
                </>
              }

              {hoursBy === "hours" &&
                <div className="form-row">
                  <label className="form-label">Work Hours</label>
                  <input className="number-input" name="totworkingHrs"
                    value={formData.totworkingHrs}
                    onChange={(e) => handlehoursChange(e)} />
                </div>
              }

              {/* Row 3 */}
              <div className="form-row">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="date-input"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
              </div>
              {/* Row 4 */}

              {/* <div className="form-row full-width">
                <label className="form-label">Ledger</label>
                <select className="select-input">
                  {employees?.map((e) => (
                    <option key={e.id} value={e.id}>{e.name}</option>
                  ))}
                </select>
              </div> */}

              <Grid item xs={6}>
                {hoursBy === "days" &&
                  <>
                    <div className="form-row">
                      <label className="form-label">Present Days</label>
                      <input className="number-input" value={formData.present_days}
                        name="present_days"
                        onChange={(e) => handledaysChange(e)} />
                    </div>

                    <div className="form-row">
                      <label className="form-label">Leave Days</label>
                      <input className="number-input" value={formData.leave_days}
                        name="leave_days"
                        onChange={(e) => handledaysChange(e)} />
                    </div>

                    <div className="form-row">
                      <label className="form-label">Extra Hours</label>
                      <input className="number-input" value={formData.extra_hrs}
                        name="extra_hrs"
                        onChange={(e) => handledaysChange(e)} />
                    </div>

                  </>
                }
              </Grid>

              <Grid item xs={6} md={6}>
                  <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>

                {
                  dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                    <DropdownWithBtn
                      key={drop.label}
                      label={drop.label}
                      id={drop.id}
                      options={drop.options}
                      value={drop.value}
                      onChange={drop.onChange}
                      isDesktop={isDesktop}
                      getOptionLabel={drop.getOptionLabel}
                      isOptionEqualToValue={drop.isOptionEqualToValue}
                      valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                      handleAddNew={drop.handleAddNew}
                      btnlabel={drop.btnlabel}
                      handleDropdownOpen={drop.handleDropdownOpen}
                      handleDropdownClose={drop.handleDropdownClose}
                    />
                  ))
                }
               {formData.punchingId && (
      <div style={{ whiteSpace: "nowrap", fontWeight: "bold",color:"#000" }}>
        Punching ID - {formData.punchingId}
      </div>
    )}
</div>
              </Grid>

              {
                extraAmt?.length > 0 &&
                <div className="summary-table-container">
                  <table className="summary-table">

                    <thead>
                      <th className="summary-th header-bg"></th>
                      {extraAmt?.map((item, index) => (
                        <th key={index} className="summary-th header-bg">{item.paytype}</th>
                      ))}
                    </thead>
                    <tbody>
                      <tr>
                        <td className="summary-td row-title">Total</td>
                        {extraAmt?.map((item, index) => (
                          <td key={index} className="summary-td">{item.balamt}</td>
                        ))}
                      </tr>

                      <tr>
                        <td className="summary-td row-title">Less</td>
                        {extraAmt?.map((item, index) => (
                          <td key={index} className="summary-td">
                            <input type="text" style={{ width: '60px' }} value={item.less}
                              onChange={(event) => handleLessChange(index, event)}
                            />
                          </td>
                        ))}
                      </tr>

                      <tr>
                        <td className="summary-td row-title">Balance</td>
                        {extraAmt?.map((item, index) => (
                          <td key={index} className="summary-td">
                            {item.bal}
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              }


              {/* Narration */}
              <div className="narration-container">
                <label className="form-label narration-label">Narration :</label>
                <textarea className="narration-textarea" name="narr" value={formData.narr} onChange={handleInputChange} />
              </div>
            </div>

            {/* Right Section */}
            <div className="right-section">
              <div className="side-box">
                {[
                  [hoursBy === "hours" ? "Per Hour Payment" : "Per Day Payment",
                  hoursBy === "hours" ? formData?.perhr_amt : formData.perday_amt],
                  ["Amount",
                    hoursBy === "hours" ? Math.round(formData?.tothr_amt) : Math.round(formData?.totday_amt)],
                  ...(hoursBy === "days"
                    ? [[`Extra Hours Amount (${formData.perhr_amt})`, formData.extrahr_amt]]
                    : []),
                  ["Leave Amount",
                    hoursBy === "days" ? Math.round(formData.leave_amt) : 0],
                  ["Deduction", Math.round(formData?.dedamt)],
                  ["Total Amount",
                    hoursBy === "hours" ? Math.round(formData?.finalhr_amt) : Math.round(formData.finalday_amt)],
                ].map(([l, v]) => (
                  <div className="side-row" key={l}>
                    <span>{l}</span>
                    <span>:</span>
                    <input className="side-input" value={v} readOnly />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Bottom Tables */}
          <div className="bottom-section">
            {/* Work Detail */}
            <div className="table-box">
              <div className="table-title">Attendance Detail</div>
              <table className="detail-table">
                <thead>
                  {attendanceHeader?.map((item, index) => (
                    <th className="detail-th" key={index}>{item}</th>
                  ))}
                </thead>
                <tbody>
                  {attendanceInfo?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.date}</td>
                      <td>{item.in1}</td>
                      <td>{item.out1}</td>
                      <td>{item.in2}</td>
                      <td>{item.out2}</td>
                      <td>{item.in3}</td>
                      <td>{item.out3}</td>
                      <td>{item.in4}</td>
                      <td>{item.out4}</td>
                      <td>{item.tothrs}</td>
                      <td>{item.exthrs}</td>
                      <td>{item.schedule_type}</td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={9}>Total</td>
                    <td>{formData.totworkingHrs}</td>
                    <td>{formData.extra_hrs}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Purchase Detail */}
            {/* <div className="table-box">
              <div className="table-title">Purchase Detail</div>
              <div className="scroll-container">
                <table className="detail-table">
                  <thead>
                    <tr>
                      <th className="detail-th">Date</th>
                      <th className="detail-th">DC No.</th>
                      <th className="detail-th">Net Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {purchaseData.map((row, idx) => (
                      <tr key={idx}>
                        <td className="detail-td">{row.date}</td>
                        <td className="detail-td">{row.dcNo}</td>
                        <td className="detail-td">{row.netAmount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div> */}
          </div>

          {/* Submit Button */}
          <div className="submit-row">
            <button className="submit-button" onClick={handleSubmit} disabled={loading === true}>Submit</button>
          </div>
        </div>
      </div>

    </>
  );
};

export default FixedEmpJobwork;